const monthSeries = ["2026-01", "2026-02", "2026-03", "2026-04", "2026-05", "2026-06"];

const execKpis = [
  { key: "mentions", label: "Total Mentions", value: 268500, exactValue: "268,500", comparison: { pctChange: 6.4, yoyChange: 14.1 } },
  { key: "impressions", label: "Total Impressions", value: 8150000, exactValue: "8,150,000", comparison: { pctChange: 8.1, yoyChange: 19.3 } },
  { key: "engagements", label: "Total Engagements", value: 614000, exactValue: "614,000", comparison: { pctChange: 5.3, yoyChange: 11.6 } },
  { key: "engagement_rate", label: "Engagement Rate", value: 7.53, exactValue: "7.53%", comparison: { pctChange: 0.5, yoyChange: 1.2 } },
  { key: "net_sentiment", label: "Net Sentiment", value: 21.2, exactValue: "21.2", comparison: { pctChange: 1.4, yoyChange: 3.6 } },
  { key: "positive_pct", label: "Positive %", value: 58.4, exactValue: "58.4%", comparison: { pctChange: 1.1, yoyChange: 2.4 } },
  { key: "yoy_growth", label: "YoY Growth", value: 14.1, exactValue: "14.1%", comparison: { pctChange: 2.4, yoyChange: 14.1 } },
  { key: "active_alerts", label: "Active Alerts", value: 12, exactValue: "12", comparison: { pctChange: -8.0, yoyChange: -12.0 } },
];

const timelinePoints = monthSeries.map((month, i) => ({
  period: month,
  mentions: 38000 + i * 2200,
  impressions: 1100000 + i * 130000,
  engagements: 83000 + i * 7000,
  positive: 21000 + i * 900,
  neutral: 12000 + i * 500,
  negative: 5000 + i * 200,
  net_sentiment: 17 + i,
}));

const platformRows = [
  { platform: "Instagram", total_impressions: 2950000, total_engagements: 242000, engagement_rate_pct: 8.2, total_reactions: 126000, total_comments: 38000, total_shares: 19000, total_video_views: 510000, total_followers_gained: 31200, total_net_follower_growth: 28100, total_saves: 24100, total_link_clicks: 15300, story_replies: 4200, active_days: 175, save_rate_pct: 0.82, video_view_rate_pct: 17.2, share_rate_pct: 0.64, avg_daily_engagements: 1383 },
  { platform: "TikTok", total_impressions: 2240000, total_engagements: 198000, engagement_rate_pct: 8.84, total_reactions: 98000, total_comments: 31200, total_shares: 25000, total_video_views: 740000, total_followers_gained: 44200, total_net_follower_growth: 39000, total_saves: 17900, total_link_clicks: 9200, story_replies: 0, active_days: 160, save_rate_pct: 0.8, video_view_rate_pct: 33.0, share_rate_pct: 1.12, avg_daily_engagements: 1238 },
  { platform: "Facebook", total_impressions: 1970000, total_engagements: 114000, engagement_rate_pct: 5.79, total_reactions: 65000, total_comments: 16100, total_shares: 14500, total_video_views: 248000, total_followers_gained: 8100, total_net_follower_growth: 6400, total_saves: 7400, total_link_clicks: 20100, story_replies: 1100, active_days: 180, save_rate_pct: 0.38, video_view_rate_pct: 12.6, share_rate_pct: 0.74, avg_daily_engagements: 633 },
  { platform: "YouTube", total_impressions: 990000, total_engagements: 60000, engagement_rate_pct: 6.06, total_reactions: 31000, total_comments: 10200, total_shares: 4000, total_video_views: 430000, total_followers_gained: 9800, total_net_follower_growth: 9100, total_saves: 1200, total_link_clicks: 6400, story_replies: 0, active_days: 95, save_rate_pct: 0.12, video_view_rate_pct: 43.4, share_rate_pct: 0.4, avg_daily_engagements: 632 },
];

const topicRows = [
  { topic_keyword: "protein snacks", mention_count: 18200, weight: 0.84, yoy_growth_pct: 21.5, brand: "Campbell", source: "social", period: "2026-Q2" },
  { topic_keyword: "spicy flavor", mention_count: 16600, weight: 0.78, yoy_growth_pct: 18.1, brand: "Campbell", source: "social", period: "2026-Q2" },
  { topic_keyword: "clean label", mention_count: 14100, weight: 0.69, yoy_growth_pct: 27.3, brand: "Campbell", source: "reviews", period: "2026-Q2" },
];

const flavourRows = [
  { flavour: "Spicy Tomato", total_mentions: 36100, social_mentions: 26000, review_mentions: 10100, total_engagements: 94000, avg_sentiment_score: 0.31, positive_pct: 58.2, market_rank: 2, market_growth_pct: 15.2 },
  { flavour: "Cheddar Heat", total_mentions: 33500, social_mentions: 23100, review_mentions: 10400, total_engagements: 88400, avg_sentiment_score: 0.25, positive_pct: 54.8, market_rank: 4, market_growth_pct: 12.1 },
  { flavour: "Garden Herbs", total_mentions: 27800, social_mentions: 16400, review_mentions: 11400, total_engagements: 59100, avg_sentiment_score: 0.36, positive_pct: 62.9, market_rank: 1, market_growth_pct: 18.6 },
];

const reviewRows = [
  { dimension_type: "flavour", dimension_value: "Spicy Tomato", review_count: 7800, avg_sentiment_score: 0.22, positive_count: 4300, negative_count: 1900, neutral_count: 1600, positive_pct: 55.1, negative_pct: 24.4 },
  { dimension_type: "flavour", dimension_value: "Garden Herbs", review_count: 6400, avg_sentiment_score: 0.37, positive_count: 4050, negative_count: 820, neutral_count: 1530, positive_pct: 63.2, negative_pct: 12.8 },
];

const alertsRows = [
  { alert_date: "2026-06-20", alert_type: "sentiment_drop", topic_keyword: "pricing", current_period_value: -8.2, previous_period_value: 3.1, yoy_change_pct: -11.3, severity: "critical", description: "Negative comments increased sharply", recommended_action: "Release value-focused messaging", brand: "Campbell", source: "social" },
  { alert_date: "2026-06-18", alert_type: "trend_spike", topic_keyword: "clean label", current_period_value: 27.3, previous_period_value: 12.8, yoy_change_pct: 14.5, severity: "high", description: "High-growth topic across reviews", recommended_action: "Prioritize clean-label creatives", brand: "Campbell", source: "reviews" },
];

const marketRows = [
  { category: "Soup", metric_name: "Market Size", metric_value: 13.5, unit: "B USD", year: 2026, source_detail: "NielsenIQ", source: "NielsenIQ" },
  { category: "Soup", metric_name: "Growth", metric_value: 4.7, unit: "%", year: 2026, source_detail: "NielsenIQ", source: "NielsenIQ" },
  { category: "Snacks", metric_name: "Market Size", metric_value: 8.1, unit: "B USD", year: 2026, source_detail: "Circana", source: "Circana" },
];

export const dashboardMockAdapter = {
  getFilterOptions: async () => ({
    brand: [{ label: "Campbell", value: "campbell" }],
    period: [{ label: "Last 90 days", value: "last_90_days" }, { label: "Last 12 months", value: "last_12_months" }],
    platform: platformRows.map((p) => ({ label: p.platform, value: p.platform })),
    source: [{ label: "social", value: "social" }, { label: "reviews", value: "reviews" }],
    sentiment: [{ label: "Positive", value: "positive" }, { label: "Neutral", value: "neutral" }, { label: "Negative", value: "negative" }],
    topicKeyword: topicRows.map((t) => ({ label: t.topic_keyword, value: t.topic_keyword })),
    flavour: flavourRows.map((f) => ({ label: f.flavour, value: f.flavour })),
    reviewDimensionType: [{ label: "flavour", value: "flavour" }],
    reviewDimensionValue: reviewRows.map((r) => ({ label: r.dimension_value, value: r.dimension_value })),
    alertSeverity: [{ label: "Critical", value: "critical" }, { label: "High", value: "high" }, { label: "Medium", value: "medium" }, { label: "Low", value: "low" }],
    alertType: [{ label: "Sentiment Drop", value: "sentiment_drop" }, { label: "Trend Spike", value: "trend_spike" }],
    marketCategory: [{ label: "Soup", value: "Soup" }, { label: "Snacks", value: "Snacks" }],
    marketMetric: [{ label: "Market Size", value: "Market Size" }, { label: "Growth", value: "Growth" }],
  }),
  getExecutiveOverview: async () => ({
    kpis: execKpis,
    trends: timelinePoints,
    sentimentDistribution: [
      { sentiment_label: "Positive", mention_count: 125000 },
      { sentiment_label: "Neutral", mention_count: 91000 },
      { sentiment_label: "Negative", mention_count: 52500 },
    ],
    topFlavours: flavourRows,
    topTopics: topicRows,
    alertsSummary: {
      totalActiveAlerts: 12,
      criticalAlerts: 2,
      severityBreakdown: { critical: 2, high: 5, medium: 3, low: 2 },
    },
    platformSummary: platformRows,
  }),
  getSocialPerformance: async () => ({ trend: timelinePoints }),
  getPlatformPerformance: async () => ({ rows: platformRows }),
  getSentimentAnalysis: async () => ({
    trend: timelinePoints,
    distribution: [
      { sentiment_label: "Positive", mention_count: 125000, mention_pct: 46.6 },
      { sentiment_label: "Neutral", mention_count: 91000, mention_pct: 33.9 },
      { sentiment_label: "Negative", mention_count: 52500, mention_pct: 19.5 },
    ],
    monthly: timelinePoints.map((item) => ({
      analysis_month: item.period,
      positive_mentions: item.positive,
      neutral_mentions: item.neutral,
      negative_mentions: item.negative,
      positive_pct: 46,
      neutral_pct: 34,
      negative_pct: 20,
      net_sentiment: item.net_sentiment,
      positive_to_negative_ratio: 2.3,
    })),
  }),
  getFlavourInsights: async () => ({ rows: flavourRows }),
  getTopicInsights: async () => ({ rows: topicRows }),
  getReviewInsights: async () => ({ rows: reviewRows }),
  getAlerts: async () => ({ rows: alertsRows }),
  getMarketContext: async () => ({ rows: marketRows }),
  getDimensionExplorer: async () => ({
    rows: platformRows.map((row) => ({ dimension: row.platform, value: row.total_engagements })),
  }),
  getDetailedPerformance: async () => ({ rows: platformRows }),
};
